import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useGetShareId } from "../diagnosticAgent/useStoredPatientCase";
import { Button } from "@mui/material";
import { CommonPatientCardTitleRow } from "fe-web-components/patientCard/commonPatientCardTitleRow";
import { EhrMainLayoutClassName } from "fe-web-components/ehrContainer/ehrMainLayoutClassName";
import clsx from "clsx";
import { PatientCardCommonActions } from "fe-web-components/patientCard/patientCardSummaryOrChartToggle";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useClinicState } from "../../clinic/clinicStateContext";
import { UsePatientSummaryApi } from "fe-common/patientSummary/useFetchPatientSummary";
import { SummarySectionType } from "fe-common/graphql";
import { DEFAULT_SORT } from "../diagnosticAgent/hooks/consts";
import { ReactComponent as SendToIcon } from "../../assets/sendToIcon.svg";
import { LandingPageLayout } from "fe-web-components/layout/landingPageLayout";
import { TabbedPatientCard } from "fe-web-components/patientCard/tabbedPatientCard";

const themeSettings = require("./clinicSettings/defaultSettings/theme.json");
//region [[ Styles ]]
const ClinicVimPatientCardView = styled(LandingPageLayout)({
  minHeight: "100vh",
  "& .top-bar": {
    display: "none",
  },
  "& .content-view": { padding: 0 },
});

const ClinicVimPatientCardHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "36px 0",
  backgroundColor: "white",
  position: "relative",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.08)",
}));

export const InjectToEhrButton = styled(Button)({
  background: "#E6E4FF",
  borderRadius: "6px",
  fontWeight: "bold",
  textTransform: "capitalize",
  color: "#5A52C3",
  minWidth: "auto",
  padding: "6px 12px 6px 0px",
  margin: "5px",
});

//endregion [[ Styles ]]
//region [[ Props ]]
export interface ClinicVimPatientCardProps {}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const ClinicVimPatientCard = ({
  ...props
}: ClinicVimPatientCardProps) => {
  const caseId = useGetShareId();
  const [
    {
      clinicData: { id: clinicId, displayName: clinicName },
    },
  ] = useClinicState();

  const sendToEhr = (e, summary: UsePatientSummaryApi, section) => {
    evt({
      category: CATEGORY.AGENT,
      action: ACTION.SEND_TO_EHR_CLICKED,
      props: {
        caseId,
        clinicName,
      },
    });

    const assessment = summary.summary.sections.find(
      (s) => s.type === SummarySectionType.Assessment,
    );
    const codes = summary.possibleCauses.possibleCauses
      .filter((d) => d.inTopCRPerSortType.includes(DEFAULT_SORT))
      .flatMap((d) => d.icd)
      .filter((icd) => icd)
      .map((icd) => ({
        name: icd.desc,
        code: icd.code,
      }));

    const data = {
      note: { content: assessment.content },
      codes,
    };

    console.log("setting ehr data", data);

    window.parent.postMessage(
      {
        message: "kahun-submit",
        data,
      },
      "*",
    );
  };

  return (
    <ClinicVimPatientCardView
      className={clsx("clinic-patient-card", EhrMainLayoutClassName)}
    >
      <ClinicVimPatientCardHeader className={"clinic-patient-card-header"}>
        <CommonPatientCardTitleRow />
      </ClinicVimPatientCardHeader>
      <TabbedPatientCard
        clinicId={clinicId}
        caseId={caseId}
        supportedSections={[]}
        themeSettings={themeSettings}
        actions={[PatientCardCommonActions.NONE]}
        summarySectionActions={[
          {
            text: "Send to EHR",
            icon: <SendToIcon />,
            onClick: sendToEhr,
          },
        ]}
      />
    </ClinicVimPatientCardView>
  );
};
